<template lang="pug">
  .b-priority(:class="cssClasses" v-if="!editable") {{ level }}
  BaseTileDropdown(v-else :opened="dropdownOpened" @close="dropdownOpened = false")
    template(#selected)
      .b-priority(:class="cssClasses" @click="dropdownOpened = !dropdownOpened").-clickable {{ level }}
    template(#default)
      .b-priority(v-for="level in levelsInDropdown" :key="level" :class="`level-${level}`" @click="onLevelSelected(level)").-clickable {{ level }}
</template>

<script>
import BaseTileDropdown from '@/components/BaseTileDropdown.vue';

export default {
  name: 'BasePriority',
  components: { BaseTileDropdown },
  model: {
    prop: 'level',
    event: 'change',
  },
  props: {
    level: Number,
    editable: Boolean,
    gray: Boolean,
  },
  data() {
    return {
      dropdownOpened: false,
    };
  },
  computed: {
    cssClasses() {
      return {
        gray: this.gray,
        [`level-${this.level}`]: true,
      };
    },
    levelsInDropdown() {
      return [...Array(10)]
        .map((_, index) => index + 1)
        .filter((i) => i !== this.level);
    },
  },
  methods: {
    onLevelSelected(level) {
      this.dropdownOpened = false;
      this.$emit('change', level);
    },
  },
};
</script>

<style scoped lang="scss">
.priority {
  font-weight: 700;
  font-size: 12px;
  border-radius: 4px;
  width: 32px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff !important;

  &--clickable {
    cursor: pointer;
  }

  &.gray {
    filter: grayscale(1);
    opacity: .6;
  }

  // todo remove color;
  &.level-1 { background-color: #DCDCDC; color: #788CA1 }
  &.level-2 { background-color: #C7E7DA; color: #1D7150 }
  &.level-3 { background-color: #C1E0EB; color: #2B69BE }
  &.level-4 { background-color: #A1CCF4; color: #006DC7 }
  &.level-5 { background-color: #6CD796; color: #288E37 }
  &.level-6 { background-color: #FED56D; color: #DFA100 }
  &.level-7 { background-color: #FFBB94; color: #E96921 }
  &.level-8 { background-color: #EAAB83; color: #BF5917 }
  &.level-9 { background-color: #F28AC6; color: #AA3E86 }
  &.level-10 { background-color: #F26363; color: #BF5917 }
}
</style>
